import EntityCollection from '@shopware-ag/admin-extension-sdk/es/data/_internals/EntityCollection';

export default EntityCollection;
